import { create } from "zustand";
import { DeliveryInput, DeliveryResponse, OrderResponse } from "../types";
import { URL } from "../../lib/apis";
// import { user } from "../parrtial";

interface DeliveryState {
  addDeliveryAddress: (input: any) => Promise<void>;
  deliveryResponse: any | null;
  loading: boolean;
}

const useAddessDeliveryStore = create<DeliveryState>((set) => ({
  deliveryResponse: null,
  loading: false,

  addDeliveryAddress: async (input: any) => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("User is not authenticated");
      return;
    }

    set({ loading: true });

    try {
      const response = await fetch(
        `${URL}/orders/deliveries`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(input),
        }
      );

      if (!response.ok) {
        throw new Error(
          `Failed to add delivery address: ${response.statusText}`
        );
      }

      const data: OrderResponse = await response.json();
      set({ deliveryResponse: data, loading: false });
    } catch (error) {
      if (error instanceof Error) {
        console.error("Error adding delivery address:", error.message);
      } else {
        console.error("Unknown error occurred");
      }
      set({ loading: false });
    }
  },
}));

export default useAddessDeliveryStore;
